export const bn = {
  // Navigation (Bengali)
  explore: 'অন্বেষণ',
  search: 'খোঁজ',
  create: 'পোস্ট তৈরি করুন',
  messages: 'বার্তা',
  notifications: 'বিজ্ঞপ্তি',
  settings: 'সেটিংস',
  profile: 'প্রোফাইল',
  logout: 'লগ আউট',
  home: 'হোম',
  
  // Authentication
  signin: 'সাইন ইন',
  signup: 'সাইন আপ',
  login: 'লগইন',
  register: 'নিবন্ধন',
  email: 'ইমেইল',
  password: 'পাসওয়ার্ড',
  confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
  firstName: 'প্রথম নাম',
  lastName: 'শেষ নাম',
  forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
  alreadyHaveAccount: 'ইতিমধ্যে অ্যাকাউন্ট আছে? সাইন ইন করুন',
  dontHaveAccount: 'অ্যাকাউন্ট নেই? সাইন আপ করুন',
  
  // Posts & Content
  recent: 'সাম্প্রতিক',
  trending: 'ট্রেন্ডিং',
  popular: 'জনপ্রিয়',
  like: 'পছন্দ',
  likes: 'পছন্দ',
  comment: 'মন্তব্য',
  comments: 'মন্তব্য',
  share: 'শেয়ার',
  delete: 'মুছুন',
  edit: 'সম্পাদনা',
  post: 'পোস্ট',
  posts: 'পোস্ট',
  title: 'শিরোনাম',
  content: 'বিষয়বস্তু',
  tags: 'ট্যাগ',
  noBlogsFound: 'কোনো ব্লগ পাওয়া যায়নি। অন্য কিছু খোঁজার চেষ্টা করুন বা প্রথমটি তৈরি করুন!',
  
  // AI Assistant
  quickActions: 'দ্রুত কার্যক্রম',
  writeCaption: 'ক্যাপশন লিখুন',
  suggestTopics: 'বিষয় সুপারিশ করুন',
  improveContent: 'বিষয়বস্তু উন্নত করুন',
  creativeIdeas: 'সৃজনশীল ধারণা',
  clearChat: 'চ্যাট পরিষ্কার করুন',
  aiWritingAssistant: 'AI লেখার সহায়ক',
  poweredByGroq: 'GROQ AI দ্বারা চালিত',
  aiGreeting: 'হ্যালো! আমি আপনার AI লেখার সহায়ক। আমি আপনাকে আকর্ষণীয় বিষয়বস্তু তৈরি করতে, ক্যাপশন লিখতে, পোস্টের বিষয় সুপারিশ করতে এবং আপনার লেখার উন্নতি করতে সাহায্য করতে পারি। আজ আপনি কী নিয়ে কাজ করতে চান?',
  askMeToHelp: 'বিষয়বস্তু, ক্যাপশন, বিষয় বা লেখার জন্য আমার সাহায্য চান...',
  aiThinking: 'AI চিন্তা করছে...',
  
  // Chat & Messages
  chat: 'চ্যাট',
  noConversationsYet: 'এখনও কোনো কথোপকথন নেই',
  ideafluxChat: 'IdeaFlux চ্যাট',
  typeMessage: 'একটি বার্তা টাইপ করুন...',
  sendMessage: 'বার্তা পাঠান',
  connectingToChat: 'চ্যাটে সংযোগ করা হচ্ছে...',
  
  // Notifications
  noNotificationsYet: 'এখনও কোনো বিজ্ঞপ্তি নেই।',
  markAllRead: 'সব পড়া হিসেবে চিহ্নিত করুন',
  clearAll: 'সব পরিষ্কার করুন',
  
  // Settings
  accountSettings: 'অ্যাকাউন্ট সেটিংস',
  displayName: 'প্রদর্শন নাম',
  emailAddress: 'ইমেইল ঠিকানা',
  languagePreference: 'ভাষার পছন্দ',
  privacySecurity: 'গোপনীয়তা ও নিরাপত্তা',
  notificationPreferences: 'বিজ্ঞপ্তির পছন্দ',
  allowDirectMessages: 'সরাসরি বার্তার অনুমতি দিন',
  letOthersMessage: 'অন্য ব্যবহারকারীদের আপনাকে ব্যক্তিগত বার্তা পাঠানোর অনুমতি দিন',
  likesOnPosts: 'পোস্টে পছন্দ',
  commentsOnPosts: 'পোস্টে মন্তব্য',
  newFollowers: 'নতুন অনুসরণকারী',
  mentions: 'উল্লেখ',
  save: 'সংরক্ষণ করুন',
  deleteAccount: 'অ্যাকাউন্ট মুছুন',
  
  // Common
  loading: 'লোড হচ্ছে...',
  cancel: 'বাতিল',
  update: 'আপডেট',
  submit: 'জমা দিন',
  back: 'পিছনে',
  next: 'পরবর্তী',
  previous: 'পূর্ববর্তী',
  online: 'অনলাইন',
  offline: 'অফলাইন',
  
  // Profile
  editProfile: 'প্রোফাইল সম্পাদনা',
  noBioYet: 'এখনও কোনো বায়ো নেই।',
  followers: 'অনুসরণকারী',
  following: 'অনুসরণ',
  recentActivity: 'সাম্প্রতিক কার্যকলাপ',
  noPostsYet: 'এখনও কোনো পোস্ট নেই',
  shareFirstPost: 'আপনার প্রথম পোস্ট শেয়ার করুন!',
  bio: 'বায়ো',
  dateOfBirth: 'জন্ম তারিখ',
  follow: 'অনুসরণ করুন',
  unfollow: 'অনুসরণ বন্ধ করুন',
  
  // Search
  discover: 'আবিষ্কার',
  findPeopleStories: 'মানুষ, গল্প এবং ধারণা খুঁজুন যা আপনার কাছে গুরুত্বপূর্ণ',
  searchByName: 'নাম, শিরোনাম বা #ট্যাগ দিয়ে খুঁজুন...',
  searchResults: 'অনুসন্ধানের ফলাফল',
  noResultsFound: 'কোনো ফলাফল পাওয়া যায়নি',
  peopleFound: 'মানুষ পাওয়া গেছে',
  
  // Form component
  pleaseSignInToCreate: 'পোস্ট তৈরি করতে সাইন ইন করুন।',
  titleRequired: 'পোস্ট প্রকাশের জন্য শিরোনাম প্রয়োজন।',
  contentRequired: 'পোস্ট প্রকাশের জন্য গল্পের বিষয়বস্তু প্রয়োজন।',
  contentTooShort: 'গল্পের বিষয়বস্তু কমপক্ষে ১০ অক্ষরের হতে হবে।',
  postUpdatedSuccessfully: 'পোস্ট সফলভাবে আপডেট হয়েছে!',
  postPublishedSuccessfully: 'পোস্ট সফলভাবে প্রকাশিত হয়েছে!',
  pleaseSignInToCreateBlogs: 'আপনার নিজস্ব IdeaFlux ব্লগ তৈরি করতে সাইন ইন করুন।',
  enterEngagingTitle: 'একটি আকর্ষণীয় শিরোনাম লিখুন...',
  story: 'গল্প',
  writeYourMasterpiece: 'আপনার মাস্টারপিস লিখুন...',
  addTags: 'ট্যাগ যোগ করুন...',
  add: 'যোগ করুন',
  publishPost: 'পোস্ট প্রকাশ করুন',
  
  // Post component
  linkCopiedToClipboard: 'লিঙ্ক ক্লিপবোর্ডে কপি হয়েছে! শেয়ার সংখ্যা আপডেট হয়েছে।',
  youAndOthers: 'আপনি এবং আরও {{count}} জন',
  unknownUser: 'অজানা ব্যবহারকারী',
  noImage: 'কোনো ছবি নেই',
  deletePost: 'পোস্ট মুছুন',
  confirmDeletePost: 'আপনি কি নিশ্চিত যে এই পোস্টটি মুছতে চান?',
  
  // Additional keys
  getNotifiedWhenSomeone: 'বিজ্ঞপ্তি পান যখন কেউ',
  likesYourPosts: 'আপনার পোস্ট পছন্দ করে',
  commentsOnYourPosts: 'আপনার পোস্টে মন্তব্য করে',
  followsYou: 'আপনাকে অনুসরণ করে',
  mentionsYou: 'আপনাকে উল্লেখ করে',
  chooseNotifications: 'আপনি কোন বিজ্ঞপ্তি পেতে চান তা বেছে নিন',
  controlWhoInteracts: 'কে আপনার সাথে যোগাযোগ করতে পারে তা নিয়ন্ত্রণ করুন',
  manageAccountInfo: 'আপনার অ্যাকাউন্টের তথ্য এবং পছন্দগুলি পরিচালনা করুন',
  emailCannotBeChanged: 'নিরাপত্তার কারণে ইমেইল পরিবর্তন করা যাবে না',
  enterDisplayName: 'আপনার প্রদর্শন নাম লিখুন',
  saving: 'সংরক্ষণ করা হচ্ছে...',
  confirmDeleteAccount: 'আপনি কি নিশ্চিত যে আপনি আপনার অ্যাকাউন্ট মুছতে চান? এটি পূর্বাবস্থায় ফেরানো যাবে না।',
  accountDeletedSuccessfully: 'অ্যাকাউন্ট সফলভাবে মুছে ফেলা হয়েছে।',
  errorDeletingAccount: 'অ্যাকাউন্ট মুছতে ত্রুটি। আবার চেষ্টা করুন।',
  settingsSavedSuccessfully: 'সেটিংস সফলভাবে সংরক্ষিত হয়েছে!',
  failedToSaveSettings: 'সেটিংস সংরক্ষণ করতে ব্যর্থ। আবার চেষ্টা করুন।',
};